<template>
  <svg
    width="820"
    height="657"
    viewBox="0 0 700 657"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g opacity="0.5">
      <g filter="url(#filter0_f_3342_6969)">
        <path
          d="M332.278 281.185C414.526 242.131 392.648 287.543 371.428 315.131C381.527 303.816 399.139 287.974 388.79 315.131C375.853 349.077 483.43 340.025 508.281 373.647C533.133 407.27 517.473 412.443 434.748 413.736C352.023 415.029 398.322 398.864 332.278 418.585C266.234 438.306 286.32 411.473 236.957 352.957C187.595 294.44 229.468 330.003 332.278 281.185Z"
          fill="#353535"
        />
      </g>
      <g opacity="0.8">
        <g clip-path="url(#clip0_3342_6969)">
          <path
            d="M283.238 354.843C298.482 393.735 342.401 412.919 381.335 397.691"
            stroke="url(#paint0_linear_3342_6969)"
            stroke-width="5"
            stroke-linecap="round"
          />
          <path
            d="M260.296 88.7869C128.474 140.343 63.4509 288.884 115.063 420.564"
            stroke="url(#paint1_linear_3342_6969)"
            stroke-width="5"
            stroke-linecap="round"
          />
          <path
            d="M284.474 229.703C338.416 191.453 413.186 204.126 451.478 258.01C489.77 311.894 477.083 386.583 423.141 424.833"
            stroke="url(#paint2_linear_3342_6969)"
            stroke-width="5"
            stroke-linecap="round"
          />
          <path
            d="M376.476 277.465C383.571 280.662 389.903 285.329 395.054 291.157C400.204 296.985 404.055 303.841 406.351 311.269C408.647 318.697 409.335 326.528 408.37 334.242"
            stroke="url(#paint3_linear_3342_6969)"
            stroke-width="5"
            stroke-linecap="round"
          />
          <path
            d="M373.565 307.462C378.81 312.612 381.82 319.613 381.948 326.958C382.075 334.303 379.309 341.404 374.246 346.732"
            stroke="url(#paint4_linear_3342_6969)"
            stroke-width="5"
            stroke-linecap="round"
          />
          <path
            d="M353.734 89.7402C485.061 89.7402 591.523 196.087 591.523 327.271"
            stroke="url(#paint5_linear_3342_6969)"
            stroke-width="5"
            stroke-linecap="round"
          />
          <path
            d="M433.986 191.372C509.122 235.646 534.102 332.381 489.78 407.436C445.459 482.491 348.619 507.444 273.482 463.17"
            stroke="url(#paint6_linear_3342_6969)"
            stroke-width="5"
            stroke-linecap="round"
          />
          <path
            d="M243.929 262.569C208.156 323.147 228.318 401.223 288.962 436.957C349.605 472.691 427.766 452.551 463.539 391.974"
            stroke="url(#paint7_linear_3342_6969)"
            stroke-width="5"
            stroke-linecap="round"
          />
          <path
            d="M445.328 172.122C359.518 121.559 248.922 150.057 198.304 235.774"
            stroke="url(#paint8_linear_3342_6969)"
            stroke-width="7.07495"
            stroke-linecap="round"
          />
          <path
            d="M385.509 273.463C355.759 255.934 317.416 265.813 299.868 295.531C282.319 325.248 292.209 363.55 321.959 381.079"
            :stroke="stroke"
            stroke-opacity="0.5"
            stroke-width="5"
            stroke-linecap="round"
          />
          <path
            d="M396.219 255.326C356.442 231.887 305.175 245.098 281.711 284.832C258.247 324.566 271.471 375.778 311.248 399.217"
            stroke="url(#paint9_linear_3342_6969)"
            stroke-width="5"
            stroke-linecap="round"
          />
          <path
            d="M267.284 276.331C239.12 324.024 254.993 385.494 302.738 413.628C350.483 441.762 412.02 425.905 440.184 378.212"
            stroke="url(#paint10_linear_3342_6969)"
            stroke-width="5"
            stroke-linecap="round"
          />
          <path
            d="M545.195 276.025C516.861 170.399 408.173 107.716 302.432 136.018C196.691 164.321 133.94 272.891 162.273 378.518"
            :stroke="stroke"
            stroke-opacity="0.5"
            stroke-width="5"
            stroke-linecap="round"
          />
          <path
            d="M545.195 276.025C516.861 170.399 408.173 107.716 302.432 136.018C196.691 164.321 133.94 272.891 162.273 378.518"
            :stroke="stroke"
            stroke-opacity="0.5"
            stroke-width="5"
            stroke-linecap="round"
          />
          <path
            d="M432.431 495.704C525.469 452.404 565.751 341.962 522.404 249.025C479.056 156.089 368.495 115.85 275.457 159.151"
            stroke="url(#paint11_linear_3342_6969)"
            stroke-width="5"
            stroke-linecap="round"
          />
          <path
            d="M272.948 280.607C298.653 236.134 355.583 220.896 400.105 246.573C444.627 272.25 459.881 329.118 434.176 373.592"
            stroke="url(#paint12_linear_3342_6969)"
            stroke-width="5"
            stroke-linecap="round"
          />
          <path
            d="M353.562 185.99C275.545 185.99 212.3 249.167 212.3 327.1C212.3 405.032 275.545 468.209 353.562 468.209"
            stroke="url(#paint13_linear_3342_6969)"
            stroke-width="5"
            stroke-linecap="round"
          />
          <path
            d="M539.064 515.88C643.41 413.568 644.969 246.129 542.546 141.895"
            :stroke="stroke"
            stroke-opacity="0.5"
            stroke-width="5"
            stroke-linecap="round"
          />
          <path
            d="M251.817 280.465C225.951 336.666 250.592 403.172 306.854 429.01C363.116 454.848 429.694 430.234 455.56 374.033"
            :stroke="stroke"
            stroke-opacity="0.5"
            stroke-width="5"
            stroke-linecap="round"
          />
          <path
            d="M417.624 356.705C433.843 321.465 418.392 279.763 383.113 263.561"
            :stroke="stroke"
            stroke-opacity="0.5"
            stroke-width="5"
            stroke-linecap="round"
          />
          <path
            d="M314.16 327.422C314.148 349.349 331.933 367.134 353.884 367.146"
            stroke="url(#paint14_linear_3342_6969)"
            stroke-width="5"
            stroke-linecap="round"
          />
          <path
            d="M416.615 464.894C492.685 430.164 526.167 340.41 491.399 264.422C456.632 188.435 366.78 154.989 290.711 189.719"
            stroke="url(#paint15_linear_3342_6969)"
            stroke-width="5"
            stroke-linecap="round"
          />
          <path
            d="M558.302 386.294C590.863 273.436 525.671 155.579 412.69 123.053C299.71 90.5271 181.725 155.649 149.164 268.507"
            stroke="url(#paint16_linear_3342_6969)"
            stroke-width="5"
            stroke-linecap="round"
          />
          <path
            d="M384.001 336.013C379.143 352.851 361.539 362.568 344.682 357.715C327.825 352.862 318.098 335.277 322.957 318.439"
            stroke="url(#paint17_linear_3342_6969)"
            stroke-width="5"
            stroke-linecap="round"
          />
          <path
            d="M116.097 327.281C116.075 196.124 222.496 89.7821 353.795 89.76"
            stroke="url(#paint18_linear_3342_6969)"
            stroke-width="5"
            stroke-linecap="round"
          />
          <path
            d="M187.477 327.364C187.492 419.081 261.937 493.42 353.753 493.404C445.569 493.389 519.989 419.025 519.973 327.308"
            stroke="url(#paint19_linear_3342_6969)"
            stroke-width="5"
            stroke-linecap="round"
          />
          <path
            d="M399.647 260.904C363.388 236.01 313.515 245.594 288.253 282.31"
            :stroke="stroke"
            stroke-width="5"
            stroke-linecap="round"
          />
          <path
            d="M607.899 199.433C538.111 61.1225 367.755 6.2872 227.399 76.9546C87.0418 147.622 29.8344 317.032 99.6224 455.342"
            :stroke="stroke"
            stroke-width="5"
            stroke-linecap="round"
          />
          <path
            d="M429.344 217.716C369.576 176.682 287.369 192.48 245.728 253.001C204.088 313.522 218.783 395.847 278.551 436.881"
            :stroke="stroke"
            stroke-width="5"
            stroke-linecap="round"
          />
          <path
            d="M396.857 143.366C497.159 166.931 559.084 268.37 535.17 369.936"
            :stroke="stroke"
            stroke-width="5"
            stroke-linecap="round"
          />
          <path
            d="M353.734 269.178C365.755 269.178 377.481 272.899 387.298 279.829C397.115 286.759 404.541 296.558 408.554 307.877C412.567 319.196 412.971 331.479 409.708 343.036C406.446 354.594 399.679 364.858 390.337 372.415"
            stroke="url(#paint20_linear_3342_6969)"
            stroke-width="5"
            stroke-linecap="round"
          />
        </g>
      </g>
      <rect width="90.8336" height="129.513" transform="matrix(-1 0 0 1 396.055 253.506)" fill="url(#pattern0)" />
      <g opacity="0.95">
        <path
          opacity="0.95"
          d="M350.466 392.877L401.936 342.711L350.466 245.848L299 342.711L350.466 392.877Z"
          fill="#323232"
          :stroke="stroke"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          opacity="0.95"
          d="M299 342.713L350.47 327.58M356.564 354.275L401.936 342.713L356.564 354.275ZM299 342.713L343.777 354.275L299 342.713ZM350.466 392.878L367.949 278.752H332.987L350.466 392.878V392.878ZM401.936 342.713L350.47 327.58L401.936 342.713Z"
          :stroke="stroke"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_f_3342_6969"
        x="-83.7177"
        y="-34"
        width="902.763"
        height="759"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="150" result="effect1_foregroundBlur_3342_6969" />
      </filter>
      <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
        <use xlink:href="#image0_3342_6969" transform="translate(-0.00728572) scale(0.00225962 0.00158479)" />
      </pattern>
      <linearGradient
        id="paint0_linear_3342_6969"
        x1="346.087"
        y1="411.477"
        x2="318.538"
        y2="341.037"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#1A1A1A" />
        <stop offset="1" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3342_6969"
        x1="234.405"
        y1="373.889"
        x2="141.129"
        y2="135.393"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#1A1A1A" />
        <stop offset="1" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_3342_6969"
        x1="451.478"
        y1="258.01"
        x2="353.878"
        y2="327.368"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#1A1A1A" />
        <stop offset="1" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_3342_6969"
        x1="408.794"
        y1="305.854"
        x2="376.476"
        y2="305.854"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#1A1A1A" />
        <stop offset="1" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_3342_6969"
        x1="381.952"
        y1="327.097"
        x2="373.565"
        y2="327.097"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#1A1A1A" />
        <stop offset="1" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_3342_6969"
        x1="591.523"
        y1="208.506"
        x2="353.734"
        y2="208.506"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#2F2F2F" />
        <stop offset="1" stop-color="#060606" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_3342_6969"
        x1="489.78"
        y1="407.436"
        x2="353.81"
        y2="327.142"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#1A1A1A" />
        <stop offset="1" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_3342_6969"
        x1="431.153"
        y1="446.816"
        x2="211.666"
        y2="317.204"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#2F2F2F" />
        <stop offset="1" stop-color="#060606" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_3342_6969"
        x1="399.502"
        y1="249.724"
        x2="244.217"
        y2="158.024"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#2F2F2F" />
        <stop offset="1" stop-color="#060606" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_3342_6969"
        x1="353.734"
        y1="327.271"
        x2="281.751"
        y2="284.764"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#1A1A1A" />
        <stop offset="1" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_3342_6969"
        x1="414.686"
        y1="421.39"
        x2="241.883"
        y2="319.345"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#2F2F2F" />
        <stop offset="1" stop-color="#060606" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint11_linear_3342_6969"
        x1="353.944"
        y1="327.427"
        x2="522.338"
        y2="248.886"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#1A1A1A" />
        <stop offset="1" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint12_linear_3342_6969"
        x1="457.447"
        y1="333.328"
        x2="296.307"
        y2="240.193"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#1A1A1A" />
        <stop offset="1" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint13_linear_3342_6969"
        x1="353.562"
        y1="327.1"
        x2="212.3"
        y2="327.1"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#1A1A1A" />
        <stop offset="1" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint14_linear_3342_6969"
        x1="334.033"
        y1="327.433"
        x2="334.011"
        y2="367.136"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#2F2F2F" />
        <stop offset="1" stop-color="#060606" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint15_linear_3342_6969"
        x1="359.579"
        y1="158.277"
        x2="485.258"
        y2="433.555"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#2F2F2F" />
        <stop offset="1" stop-color="#060606" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint16_linear_3342_6969"
        x1="353.733"
        y1="327.4"
        x2="412.572"
        y2="123.019"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#2F2F2F" />
        <stop offset="1" stop-color="#060606" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint17_linear_3342_6969"
        x1="344.682"
        y1="357.715"
        x2="353.461"
        y2="327.221"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#2F2F2F" />
        <stop offset="1" stop-color="#060606" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint18_linear_3342_6969"
        x1="234.926"
        y1="89.78"
        x2="234.966"
        y2="327.261"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#2F2F2F" />
        <stop offset="1" stop-color="#060606" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint19_linear_3342_6969"
        x1="353.725"
        y1="327.336"
        x2="353.753"
        y2="493.404"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#2F2F2F" />
        <stop offset="1" stop-color="#060606" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint20_linear_3342_6969"
        x1="411.891"
        y1="320.796"
        x2="353.734"
        y2="320.796"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#2F2F2F" />
        <stop offset="1" stop-color="#060606" stop-opacity="0" />
      </linearGradient>
      <clipPath id="clip0_3342_6969">
        <rect
          width="625"
          height="669"
          rx="20"
          transform="matrix(-4.37114e-08 -1 -1 4.37114e-08 685 641)"
          fill="white"
        />
      </clipPath>
      <image
        id="image0_3342_6969"
        width="449"
        height="631"
        xlink:href="data:image/png;base64,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"
      />
    </defs>
  </svg>
</template>

<script>
export default {
  props: ['stroke']
}
</script>
